export const pdfImageSelector = ({ federalProforma }) => federalProforma.pdfImage;

export const isFetchingPdfImageSelector = ({ federalProforma }) =>
  federalProforma.isFetchingPdfImage;

export const lastRefreshProFormaReturnSelector = ({ federalProforma }) =>
  federalProforma.lastRefreshProFormaReturn;
